import { defineComponent as _defineComponent } from 'vue'
import { useSlots } from "vue";
import { ApiGetLoadStatus, ApiGetLoadStatusType } from "@/modules/types/apiLoadStatusType";
import ApiErrorDisplay from "./ApiErrorDisplay.vue";
import ApiLoadingDisplay from "./ApiLoadingDisplay.vue";

interface Props {
	/**
	 * APIステータス。
	 */
	status: ApiGetLoadStatusType;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    status: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * APIステータス。
	 */
	status: ApiGetLoadStatusType;
}
/**
 * GETリクエストでの、APIローディング表示コンテンツ。
 */


const slots = useSlots();
/**
 * エラーのslot内容があるかどうか。
 */
const isExistErrorSlot = (): boolean => {
	if (!slots.error) {
		return false;
	}
	return true;
};

const __returned__ = { props, slots, isExistErrorSlot, ApiGetLoadStatus, ApiErrorDisplay, ApiLoadingDisplay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})